module.exports = __webpack_public_path__ + "img/asana_logo.28f50152.png";